import React from 'react';
import { ForumApplication } from '../../models/ForumApplication';
import './AppliedPostCard.scss';

type Props = {
  application: ForumApplication;
};

const AppliedPostCard = ({ application: app }: Props) => {
  const isActive = app.forumPostIsOpen && !app.forumPostIsExpired;
  const isExpiredOpen = app.forumPostIsOpen && app.forumPostIsExpired;

  const pillLabel = isActive ? '掲載中' : isExpiredOpen ? '掲載終了' : '受付終了';
  const pillCls = isActive ? 'open' : 'closed';

  const deadlineRel = isActive ? `あと${ app.forumPostDaysLeft }日` : '掲載終了';
  const countdownCls = isActive && app.forumPostDaysLeft <= 20 ? 'urgent' : (!isActive ? 'ended' : '');

  return (
    <li className={ `dp-post${ !isActive ? ' is-closed' : '' }` }>
      <div className="dp-top">
        <div className="dp-head">
          <span className={ `dp-status-pill ${ pillCls }` }>
            { pillLabel }
          </span>
          { app.forumPostDoneeNameF && (
            <strong className="dp-poster">{ app.forumPostDoneeNameF }様</strong>
          ) }
          { app.forumPostDoneeAgeText && (
            <span className="dp-age">{ app.forumPostDoneeAgeText }</span>
          ) }
        </div>

        <div className="dp-meta">
          { app.forumPostPostedAtText && (
            <span>投稿 <strong>{ app.forumPostPostedAtText }</strong></span>
          ) }
          { app.forumPostPostedAtText && app.forumPostExpiresAtText && (
            <span className="dp-dot" />
          ) }
          { app.forumPostExpiresAtText && (
            <span>
              締切 <strong>{ app.forumPostExpiresAtText }</strong>
              { isActive && (
                <em className={ `dp-countdown${ countdownCls ? ` ${ countdownCls }` : '' }` }>{ deadlineRel }</em>
              ) }
            </span>
          ) }
        </div>

        { app.forumPostDescription && (
          <p className="dp-desc">{ app.forumPostDescription }</p>
        ) }

        <div className="dp-chips">
          { app.forumPostAreaText && (
            <span className="dp-chip dp-chip--area">{ app.forumPostAreaText }</span>
          ) }
          { app.forumPostBloodTypeChips.map(v => (
            <span key={ v } className="dp-chip">{ v }</span>
          )) }
          { app.forumPostAgeRangeTexts.map(v => (
            <span key={ `a${ v }` } className="dp-chip">{ v }</span>
          )) }
          { app.forumPostBodyFigureTexts.map(v => (
            <span key={ `b${ v }` } className="dp-chip">{ v }</span>
          )) }
          { app.forumPostHeightRangeTexts.map(v => (
            <span key={ `h${ v }` } className="dp-chip">{ v }</span>
          )) }
        </div>
      </div>

      <div className="dp-mine">
        <div className="dp-mine-head">
          <span className="dp-mine-label">あなたの応募コメント</span>
          <span className="dp-mine-time">{ app.createdAtText } に応募</span>
        </div>
        <p className="dp-mine-text">{ app.comment }</p>
      </div>
    </li>
  );
};

export default AppliedPostCard;
